<template>
  <v-app-bar app clipped-left>
    <img alt="Vue logo" height="35" src="@/assets/logo_header.svg" />
    <v-spacer />
    <v-menu close-on-click v-model="showInfoUser" offset-y>
      <template v-slot:activator="{ on }">
        <v-card-actions link v-on="on">
          <v-avatar>
            <v-img
              height="35"
              width="60"
              :src="userDetail.avatar"
              class="mr-2"
            />
          </v-avatar>
          <v-list-item-title style="cursor: pointer">{{
            userDetail.email
          }}</v-list-item-title>
          <v-icon size="15">{{
            !showInfoUser ? "fas fa-caret-down" : "fas fa-caret-up"
          }}</v-icon>
        </v-card-actions>
      </template>
      <v-list>
        <!-- my profile -->
        <!-- <v-list-item @click="showDialogProfile = true">
          <v-list-item-icon>
            <v-icon>mdi-account-box</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{$t('my-profile-title')}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item @click="showDialogChangePassword = true">
          <v-list-item-icon>
            <v-icon>mdi-key</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{$t('change-password-title')}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>-->

        <!-- logout -->
        <v-list-item @click="handleLogout">
          <v-list-item-icon>
            <v-icon>mdi-logout-variant</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>ログアウト</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
    <!-- <MyProfile v-model="showDialogProfile" /> -->
    <!-- <ChangePassword :key="dialogChangePassword" v-model="showDialogChangePassword" /> -->
  </v-app-bar>
</template>
<script>
import mixin from "@/mixin";
export default {
  mixins: [mixin.Auth],
  name: "Header",
  store: ["Auth"],
  // components: { MyProfile },
  props: {
    menuRouter: {
      type: Array,
    },
  },
  created() {
    this.userDetail = this.$ls.get("userDetail");
    console.log("userDetail: ", this.userDetail);
  },
  data() {
    return {
      showInfoUser: false,
      showDialogProfile: false,
      showDialogChangePassword: false,
      dialogChangePassword: 0,
      userDetail: {},
    };
  },
  watch: {
    showDialogChangePassword: function () {
      this.dialogChangePassword++;
    },
  },
  methods: {
    handleShowMyProfile() {
      this.showDialogProfile = true;
    },
  },
};
</script>